import DishOptionCreator from "./option/DishOptionCreator";
import Button from "../../../../button/Button";
import PropTypes from "prop-types";
import { generateEmptyOption } from "../../../../../../utils/model/dish";
import './DishOptionsCreator.scss';

const DishOptionsCreator = ({id, onChange, options}) => {
    const handleOptionsChange = (newOptions) => {
        onChange(newOptions, 'options');
    }
    const handleAddOption = () => {
        const newOptions = [...options, generateEmptyOption()];
        handleOptionsChange(newOptions);
    };
    const handleEditOption = (newOption, optionIndex) => {
        const newOptions = options.map(
            (option, index) => optionIndex === index ? newOption : option
        );
        handleOptionsChange(newOptions);
    };
    const handleRemoveOption = (optionIndex) => {
        const newOptions = options.filter((_, index) => index !== optionIndex);
        handleOptionsChange(newOptions);
    }
    return (
        <div className="dish-options-creator">
            <div className="dish-options-creator__options">
                {options.map((option, optionIndex) => (
                    <DishOptionCreator
                        key={`${id}-${optionIndex}`}
                        id={id}
                        optionIndex={optionIndex}
                        option={option}
                        onRemove={handleRemoveOption}
                        onChange={handleEditOption}
                    />
                ))}
            </div>
            <Button label="Add option" onClick={handleAddOption}/>
        </div>
    );
};

DishOptionCreator.propTypes = {
    id: PropTypes.string.isRequired,
    options: PropTypes.array,
    onChange: PropTypes.func.isRequired
}

DishOptionsCreator.defaultProps = {
    options: []
}

export default DishOptionsCreator;
